module.exports = __webpack_public_path__ + "static/media/icon-close-circle.fce7e30e.svg";